import React, { useMemo } from 'react'
import classNames from 'classnames'
import { Breadcrumbs } from '@/components/ui'
import type { TLandingBreadcrumbsProps } from './types'
import './styles.scss'

export const LandingBreadcrumbs: React.FC<TLandingBreadcrumbsProps> = ({ rootBreadcrumbs = [], currentPageBreadcrumb, className }) => {
  const breadcrumbs = useMemo(
    () =>
      [...rootBreadcrumbs, currentPageBreadcrumb].map(breadcrumb => ({
        ...breadcrumb,
        className: 'landingBreadcrumbs__breadcrumb text_small',
      })),
    [currentPageBreadcrumb, rootBreadcrumbs],
  )

  return <Breadcrumbs className={classNames('landingBreadcrumbs', className)} customBreadcrumbs={breadcrumbs} />
}
